import React, { useState, useEffect } from 'react';
import { db } from '../../services/firebase';
import { collection, addDoc, deleteDoc, doc, getDocs } from 'firebase/firestore';
import { useBooks } from '../../hooks/useBooks';

const ManageFeatured = () => {
  const { books } = useBooks();
  const [currentFeatured, setCurrentFeatured] = useState([]);
  const [selectedBookId, setSelectedBookId] = useState('');

  useEffect(() => {
    fetchCurrent();
  }, []);

  const fetchCurrent = async () => {
    const snapshot = await getDocs(collection(db, 'featuredBooks'));
    setCurrentFeatured(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const addToFeatured = async () => {
    if (!selectedBookId) return;
    await addDoc(collection(db, 'featuredBooks'), {
      bookId: selectedBookId,
      addedAt: new Date()
    });
    fetchCurrent();
  };

  const removeFromFeatured = async (docId) => {
    await deleteDoc(doc(db, 'featuredBooks', docId));
    fetchCurrent();
  };

  const availableBooks = books.filter(b => !currentFeatured.some(f => f.bookId === b.id));

  return (
    <div>
      <h2>Manage Featured Books</h2>
      <select value={selectedBookId} onChange={e => setSelectedBookId(e.target.value)}>
        <option value="">Select book to add</option>
        {availableBooks.map(book => (
          <option key={book.id} value={book.id}>{book.title} by {book.author}</option>
        ))}
      </select>
      <button onClick={addToFeatured}>Add</button>

      <h3>Current Featured ({currentFeatured.length})</h3>
      <ul>
        {currentFeatured.map(item => {
          const book = books.find(b => b.id === item.bookId);
          return (
            <li key={item.id}>
              {book?.title} by {book?.author}
              <button onClick={() => removeFromFeatured(item.id)}>Remove</button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ManageFeatured;